import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { Quote } from 'lucide-react';
export function LeadershipSection() {
  return <section id="leadership" className="py-20 md:py-32 bg-dark-bg" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-266">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-267">
          <motion.div variants={fadeInUp} className="mb-20 max-w-4xl mx-auto text-center relative" data-id="element-268">
            <Quote className="w-12 h-12 text-gold/20 absolute -top-8 -left-8 transform -scale-x-100" data-id="element-269" />
            <blockquote className="text-2xl md:text-4xl font-serif italic text-white leading-relaxed mb-8 border-l-4 border-gold pl-6 md:pl-0 md:border-l-0" data-id="element-270">
              "Technology leadership isn't about choosing the newest tools —
              it's about engineering systems and cultures that thrive under
              uncertainty."
            </blockquote>
            <cite className="not-italic text-slate-400 font-sans text-sm" data-id="element-271">
              — Michael Parks,{' '}
              <span className="text-gold" data-id="element-272">CTO Summit Keynote 2024</span>
            </cite>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-273">
            <motion.div variants={fadeInUp} className="bg-dark-card border border-dark-border p-8 rounded-xl" data-id="element-274">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-275">
                Resilience by Design
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-276">
                Building systems that assume failure is inevitable. Chaos
                engineering and redundancy are not optional add-ons, but
                fundamental architectural principles.
              </p>
            </motion.div>

            <motion.div variants={fadeInUp} className="bg-dark-card border border-dark-border p-8 rounded-xl" data-id="element-277">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-278">
                Data-Driven Decisions
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-279">
                Every technical investment must be backed by clear metrics. If
                we can't measure the impact on the business, we don't build it.
              </p>
            </motion.div>

            <motion.div variants={fadeInUp} className="bg-dark-card border border-dark-border p-8 rounded-xl" data-id="element-280">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-281">
                People First
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-282">
                Great systems are built by great teams. My primary role is to
                remove blockers, foster psychological safety, and enable
                engineering excellence.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}